import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=d0bc2018&scoped=true&"
import script from "./AdminSidebar.vue?vue&type=script&lang=js&"
export * from "./AdminSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=d0bc2018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bc2018",
  null
  
)

export default component.exports